var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6571 3.96077C26.5336 0.714575 21.4596 0.714575 18.3228 3.96077L16.9998 5.33835L15.6768 3.96077C12.5534 0.714575 7.47929 0.714575 4.34258 3.96077C1.21914 7.20696 1.21914 12.458 4.34258 15.7045L16.9727 28.8122L17 28.785L17.0273 28.8122L29.6574 15.7045C32.7809 12.4583 32.7809 7.20732 29.6574 3.96077H29.6571Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5476 6.05499C24.9447 3.34983 20.7163 3.34983 18.1024 6.05499L16.9998 7.20298L15.8973 6.05499C13.2945 3.34983 9.06608 3.34983 6.45215 6.05499C3.84928 8.76015 3.84928 13.136 6.45215 15.8415L16.9773 26.7646L17 26.7418L17.0227 26.7646L27.5479 15.8415C30.1507 13.1363 30.1507 8.76046 27.5479 6.05499H27.5476Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.438 8.14922C23.3557 5.98509 19.973 5.98509 17.8819 8.14922L16.9999 9.06761L16.1179 8.14922C14.0356 5.98509 10.6529 5.98509 8.56172 8.14922C6.47943 10.3133 6.47943 13.814 8.56172 15.9784L16.9818 24.7169L17 24.6987L17.0182 24.7169L25.4383 15.9784C27.5206 13.8143 27.5206 10.3136 25.4383 8.14922H25.438Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3285 10.2434C21.7668 8.62035 19.2298 8.62035 17.6614 10.2434L16.9999 10.9322L16.3384 10.2434C14.7767 8.62035 12.2396 8.62035 10.6713 10.2434C9.10957 11.8665 9.10957 14.492 10.6713 16.1153L16.9864 22.6692L17 22.6555L17.0136 22.6692L23.3287 16.1153C24.8904 14.4922 24.8902 11.8667 23.3285 10.2434Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4179 12.0132C20.3119 10.8638 18.5153 10.8638 17.4046 12.0132L16.9362 12.501L16.4677 12.0132C15.3618 10.8638 13.5651 10.8638 12.4545 12.0132C11.3485 13.1626 11.3485 15.0219 12.4545 16.1715L16.9266 20.8127L16.9363 20.803L16.9459 20.8127L21.418 16.1715C22.524 15.022 22.5239 13.1627 21.4179 12.0132Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9393 13.4791C19.1977 12.7084 17.9931 12.7084 17.2484 13.4791L16.9343 13.8062L16.6201 13.4791C15.8786 12.7084 14.6739 12.7084 13.9292 13.4791C13.1877 14.2498 13.1877 15.4965 13.9292 16.2673L16.9278 19.3793L16.9343 19.3728L16.9408 19.3793L19.9394 16.2673C20.6809 15.4966 20.6808 14.2499 19.9393 13.4791Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4646 14.9451C18.0874 14.5531 17.4747 14.5531 17.096 14.9451L16.9362 15.1114L16.7765 14.9451C16.3993 14.5531 15.7866 14.5531 15.4079 14.9451C15.0307 15.3371 15.0307 15.9711 15.4079 16.3632L16.933 17.9459L16.9362 17.9426L16.9395 17.9459L18.4646 16.3632C18.8418 15.9712 18.8417 15.3371 18.4646 14.9451Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart5);
export default __webpack_public_path__ + "static/media/Heart-5.e003df26513252c9eeb9de568525b53e.svg";
export { ForwardRef as ReactComponent };